import * as XLSX from 'xlsx';

const DownloadEmployeeExcel = (employeeList, companyName, setOpenBackdrop) => {
  // 1. Validate Data
  const dataList = Array.isArray(employeeList) ? employeeList : [];

  if (dataList.length === 0) {
    alert("No employee data found to export!");
    return;
  }

  if (typeof setOpenBackdrop === 'function') {
    setOpenBackdrop(true);
  }

  try {
    // 2. Data formatting for Excel export
    const excelData = dataList.map((item, idx) => {
      // Sites Array to String handling
      const siteNames = Array.isArray(item.site_names)
        ? item.site_names.join(', ')
        : (item.site_names || '-');

      return {
        'S.No': idx + 1,
        'Employee Code': item.employee_code || '-',
        'Employee Name': item.contact_name || item.fname || 'N/A',
        'Mobile': item.mobile || '-',
        'Email': item.email || '-',
        'Designation': item.designation_name || '-',
        'Department': item.department_name || '-',
        'Status': item.status === 1 ? 'Active' : 'Inactive',
        'City': item.city || '-',
        'State': item.State || item.state || '-',
        'Site(s)': siteNames,
      };
    });

    // 3. Create Worksheet & Workbook
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');

    // 4. Adjust Column Widths dynamically
    const columnWidths = [
      { wch: 6 },  // S.No
      { wch: 15 }, // Employee Code
      { wch: 25 }, // Employee Name
      { wch: 15 }, // Mobile
      { wch: 30 }, // Email
      { wch: 20 }, // Designation
      { wch: 20 }, // Department
      { wch: 12 }, // Status
      { wch: 15 }, // City
      { wch: 15 }, // State
      { wch: 30 }, // Site(s)
    ];
    worksheet['!cols'] = columnWidths;

    // 5. Save the file
    const timestamp = new Date().getTime();
    const safeCompanyName = (companyName || 'Company').replace(/\s+/g, '_');
    XLSX.writeFile(workbook, `${safeCompanyName}_Employee_Report_${timestamp}.xlsx`);

  } catch (error) {
    console.error("Excel Generation Error:", error);
    alert("Something went wrong while generating the Excel file.");
  } finally {
    if (typeof setOpenBackdrop === 'function') {
      setOpenBackdrop(false);
    }
  }
};

export default DownloadEmployeeExcel;